import { FormikProps, FormikValues } from "formik";

import { AppDispatch, store } from "../../app/store";
import { canRenewExpiredToken, goToStep } from "../../app/utils";
import { authEmail } from "../../connectors/connectors";
import {
  updateDraftBase,
  updateSignatureRequestId,
  updateToken,
} from "../../reducers/authReducer";
import { onUpdateActiveTemplate } from "../../reducers/activeTemplateReducer";
import { onUpdateFormData } from "../../reducers/onboardingDataReducer";
import { getPartnerCompanyType } from "../../utils";
import { getCompanyData } from "../../utils/companies";
import { getDraftBase } from "../../utils/draftBase";
import { mergeDeep } from "../../components/TemplateInterpreter/utils";

const STEP_ONE_FIELDS = [
  "email",
  "cuit",
  "identityDocument",
  "referredBool",
  "referrer",
  "merchant",
];

const getStepOneValues = (values: FormikValues) => {
  const stepOneValues: FormikValues = Object.fromEntries(
    STEP_ONE_FIELDS.filter((field) => values[field] !== undefined).map(
      (field) => [field, values[field]],
    ),
  );

  const businessCuit = values.businessInformation?.cuit;
  if (businessCuit) stepOneValues.businessInformation = { cuit: businessCuit };

  return stepOneValues;
};

//The token lasts 48 hours. Once expired, the code is requested again with the
//same body as step 1 (the back keeps the draft only if it matches) and the
//user validates the email again. Returns whether it did
export const renewExpiredToken = async ({
  dispatch,
  formik,
  oldAuth,
}: {
  dispatch: AppDispatch;
  formik: FormikProps<FormikValues>;
  oldAuth?: boolean;
}) => {
  if (!canRenewExpiredToken()) return false;

  const { authentication, activeTemplate } = store.getState();
  const { token } = authentication;

  const { values } = formik;
  const partnerCompanyType = getPartnerCompanyType(values);
  const draftBase = getDraftBase(values);

  //Before the reset, so a failed request leaves the user where they were
  const res = await authEmail({
    email: values.email,
    es: true,
    companyType: getCompanyData().companyName,
    ...(partnerCompanyType ? { partnerCompanyType } : {}),
    ...(oldAuth ? { oldAuth } : {}),
    draftBase,
  });

  const stepOneValues = getStepOneValues(values);

  dispatch({ type: "reset-store" });
  //Without a template, TemplateInterpreter reboots /empresarial on step 1
  dispatch(onUpdateActiveTemplate(activeTemplate));
  //Kept expired: the token step reads it to ask for the email again
  dispatch(updateToken(token));
  dispatch(updateSignatureRequestId(res.data.signatureRequestId));
  dispatch(updateDraftBase(draftBase));
  dispatch(onUpdateFormData(stepOneValues));
  formik.resetForm({ values: mergeDeep(formik.initialValues, stepOneValues) });
  goToStep({ dispatch, step: 2 });

  return true;
};
